/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (operations) => ({
    type: actions.OPERATIONS_RECEIVE,
    payload: { operations },
});